import flow from 'lodash/fp/flow';

import type { RootState } from '../../../configuration/setup/store';

const baseSelector = (state: RootState) => state.routes;

export const getSuggestedRoutes = flow(baseSelector, subState => subState.suggestedRoutes);
export const getSelectedRoute = flow(baseSelector, subState => subState.selectedRoute);
export const isFetchRoutesInProgress = flow(baseSelector, subState => subState.fetchRoutesInProgress);
export const getFetchRoutesError = flow(baseSelector, subState => subState.fetchRoutesError);
